<template>
  <div class="sightseeing-card">
    <div class="card-bd">
      <van-radio-group v-model="checkData" :disabled="!isShowRadio">
        <!--精品游-->
        <div class="boutique-tour-bpx" v-if="listData[2]">
          <div class="item-top-tag-box">
            <div :class="isTravelPage?'item-top-tag':'item-top-tag left'">精品游</div>
          </div>
          <div class="list-box" v-for="(payItem,index) in listData[2]" :key="index">
            <div class="list-hd">
              <van-radio :name="payItem.id" :disabled="orderStatus==1&&payItem.cannotChange" v-if="isShowRadio" @click="checkItem(payItem.id,false)">
                <div slot="default" class="item-hd flex-between-box">
                  <div class="item-hd-left blue-color">{{payItem.shorexName}}</div>
                  <div class="item-hd-right"> <span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人<div>(上船自动房卡扣款)</div></div>
                </div>
                <template #icon="props">
                  <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                  >
                  <i class="checked-item" v-if="props.checked"></i>
                </template>
              </van-radio>
              <div v-else-if="isTravelPage">
                <div slot="default" class="item-hd flex-center-box">
                  <div class="item-hd-left">
                    <div class="blue-color" style="margin-bottom:5px">{{payItem.shorexName}}</div>
                    <div class="price"><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人 </div>
                  </div>
                  <div class="item-hd-right">
                    <van-button type="default" size="small" class="btn-common small item-btn btn-cart" :disabled="checkData === payItem.id" @click="checkItem(payItem.id, false)">
                      <img class="icon" src="../../assets/icons/icon_cart.png" alt="">
                      {{checkData === payItem.id ? '已预订' :'立即预订'}}
                    </van-button>
                    <!-- <a href="javascript:;" class="btn-common small item-btn btn-cart" @click="checkItem(payItem.id)"></a> -->
                  </div>
                </div>
              </div>
              <div v-else>
                <div slot="default" class="item-hd flex-between-box only-detail">
                  <div class="item-hd-left">
                    <div class="blue-color">{{payItem.shorexName}}</div>
                    <div class="price"><span class="price-color">{{priceFormat(payItem.price)}}</span> 美元 / 人  <span class="number">x{{personNumber}}</span></div>
                  </div>
                  <div class="item-hd-right"> <span class="price-color">{{priceFormat(payItem.price*personNumber)}}</span> 美元 <div></div></div>
                </div>
              </div>
            </div>
            <div class="list-bd">
              <TourList :listData="payItem.shorexTours"/>
            </div>
          </div>
        </div>
        <!--常规游-->
        <div class="routine-tour-box" v-if="listData[1]">
          <div class="item-top-tag-box isTag">
            <div :class="isTravelPage?'item-top-tag':'item-top-tag left'">常规游</div>
            <div class="item-top-tag-price">皇家赠送</div>
          </div>
          <div class="list-box" v-for="(freeItem,index) in listData[1]" :key="index">
            <div class="list-hd">
              <van-radio :name="freeItem.id" :disabled="orderStatus==1&&freeItem.cannotChange" v-if="isShowRadio" @click="checkItem(freeItem.id, true)">
                <div slot="default" class="item-hd flex-between-box">
                  <div class="item-hd-left blue-color">{{freeItem.shorexName}}</div>
                  <!-- <div class="item-hd-right"> <span class="price-color">{{freeItem.price}}</span> 美元 / 人<div>(上房自动房卡扣款)</div></div> -->
<!--                  <div class="item-hd-right"><span class="price-color">皇家赠送</span></div>-->
                </div>
                <template #icon="props">
                  <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                  >
                  <i class="checked-item" v-if="props.checked"></i>
                </template>
              </van-radio>
              <div v-else>
                <div class="item-hd flex-between-box">
                  <div class="item-hd-left blue-color">{{freeItem.shorexName}}</div>
<!--                  <div class="item-hd-right"> <span class="price-color">皇家赠送</span></div>-->
                </div>
              </div>
            </div>
            <div class="list-bd">
              <div class="list-bd-top flex-between-box" v-for="(freeListItem , index ) in freeItem.shorexTours" :key="index">
                <van-image
                width="1.9rem"
                height="1.2rem"
                fit="cover"
                :src="freeListItem.image ? freeListItem.image : require('../../assets/default/changguiyou_pic.jpg')"
                />
                <div class="top-text-box">
                  <div class="title" v-html="freeListItem.shorexName"></div>
                  <div class="route" v-html="freeListItem.shorexBrief"></div>
                  <div class="duration">时长：{{freeListItem.duration}}</div>
<!--                  <div v-if="freeItem.shorexTours.length === (index+1)" class="list-del">-->
<!--                    <van-button v-if="checkData === freeItem.id" @click="checkItem(freeItem.id, true)" class="del-btn btn-linear-gradient">删除</van-button>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div v-if="isShowTour" class="top-text-tools">
            <!--                    <van-button v-if="checkData === freeItem.id" @click="checkItem(freeItem.id, true)" class="item-btn btn-linear-gradient del">删除</van-button>-->
            <div @click="goCart" class="tools-btn btn-linear-gradient btn">升级精品游</div>
          </div>
        </div>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import TourList from './TourList'
import groupBy from 'lodash/groupBy'
import { showAlert } from '@/utils/tools'
import api from '@/api'
import { checkOrderState } from '@/plugins/common'
import { setCookie, getCookie } from '@/utils/cookie'
import { Dialog } from 'vant'
export default {
  name: 'SightseeingCard',

  components: {
    TourList
  },

  data () {
    return {
      checkData: '',
      listData: {},
      activeIcon: require('../../assets/check_ico_on.png'),
      inactiveIcon: require('../../assets/check_ico.png'),
      checkDataBack: '',
      defaultFreeShorexId: ''
    }
  },

  props: {
    isShowRadio: {
      type: Boolean,
      default: false
    },
    isTravelPage: {
      type: Boolean,
      default: false
    },
    checkId: Number,
    orderStatus: {
      type: Number,
      default: 0
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    },
    personNumber: {
      type: Number,
      default: 0
    },
    isShowDel: {
      type: Boolean,
      default: false
    },
    isShowTour: {
      type: Boolean,
      default: false
    },
    canDeletedPayShorex: {
      type: Boolean,
      default: false
    },
    isCardOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showCartCancelOrder() {
      return this.$store.state.showCartCancelOrder
    }
  },
  watch: {
    cardData (val) {
      // console.log(val)
      this.listData = this.editListData(val)
      if(this.listData) {
        let index = Object.keys(this.listData)[0];
        this.defaultFreeShorexId = this.listData[index][0].id;
      }
    },
    checkId (val) {
      this.checkData = val
      this.checkDataBack = val
    }
  },
  created () {
    this.listData = this.editListData(this.cardData)
    if(this.listData) {
      let index = Object.keys(this.listData)[0];
      this.defaultFreeShorexId = this.listData[index][0].id;
    }
    // this.$store.commit('store', {
    //   showCartCancelOrder: false
    // });
    this.checkData = this.checkId
    this.checkDataBack = this.checkId
  },
  methods: {
    priceFormat (current) {
      return current % 1 === 0 ? current : current.toFixed(2)
    },
    //点击岸上观光单选框
    async checkItem(val, isFree) {
      // console.log('val--'+val+'===checkDataBack--'+this.checkDataBack+'===checkData--'+this.checkData+'===isFree--'+isFree)
      // this.doCheckOrderState(val, isFree);
      await checkOrderState((checkResult, orderStatus, orderIsInChange) => {
        //订单状态检查或订单更改为修改中状态报错
        if (checkResult) {
          if (checkResult === 'cancel') {
            this.checkData = this.checkId
          } else {
            showAlert(checkResult)
          }
        } else {
          // 订单未提交
          if (orderStatus === 0) {
            //取消勾选
            if(val === this.checkDataBack) {
              this.checkProduct(0)
            } else {
              this.checkProduct(val)
            }
          } else if (orderStatus === 1 && orderIsInChange) {
            //订单已提交 && 订单可变更
            // 取消勾选
            if(val === this.checkDataBack && !this.$store.state.showCartCancelOrder) {
              //精品游反选
              if(!isFree) {
                if(this.canDeletedPayShorex) {
                  this.checkProduct(0)
                  if(this.defaultFreeShorexId) this.checkProduct(this.defaultFreeShorexId);
                } else {
                  showAlert('仅可切换不可取消，如需取消请联系皇家行前订客服')
                }
              } else {
                //常规游反选

                //可取消订单
                // if(canCancelOrder) {
                //   Dialog.confirm({
                //     message: '请点击”取消订单“确认取消常规游行程'
                //   }).then(() => {
                //     this.checkData = "";
                //     this.$emit('shorexChange', {
                //       showCartCancelOrder: true
                //     });
                //   }).catch(() => {
                //     this.checkData = this.checkId
                //   })
                // } else {
                //   if(this.isCardOrder) {
                //     Dialog.confirm({
                //       message: '确定要删除该产品？'
                //     }).then(() => {
                //       this.checkProduct(0)
                //     }).catch(() => {
                //       this.checkData = this.checkId
                //     })
                //   } else {
                //     this.checkProduct(0)
                //   }
                // }
              }
            } else {
              //勾选其它岸上观光 && 是精品游
              if (!this.isTravelPage && !isFree) {
                Dialog.confirm({
                  message: '该操作将替换原有线路'
                }).then(() => {
                  this.checkProduct(val)
                }).catch(() => {
                  this.checkData = this.checkId
                })
              } else {
                this.checkProduct(val)
              }
            }
          } else {
            // this.$emit('checkval')
            this.checkProduct(val)
          }
        }
      }, this.isTravelPage)
    },
    editListData (val) {
      for (let index = 0; index < val.length; index++) {
        if (val[index].id === this.checkId) {
          val[index].checkStatus = true
        } else {
          val[index].checkStatus = false
        }
      }
      return groupBy(val, 'shorexType')
    },
    // 选择产品
    async checkProduct (val) {
      if(val!==0) {
        this.$emit('shorexChange', {
          showCartCancelOrder: false
        });
      }
      const { errCode, errMsg } = await api.addProduct({ shorexId: val })
      if (errCode === 0) {
        this.checkDataBack = val
        this.$emit('checkval')
        if (this.isTravelPage && !getCookie('shorexId')) {
          setCookie('shorexId', val)
        }
      } else {
        this.checkData = this.checkDataBack
        showAlert(errMsg)
      }
    },
    // 删除产品
    async deleteProduct (val) {
      const { errCode, errMsg } = await api.deleteProduct({ shoppingCartId: val })
      if (errCode === 0) {
        this.checkData = ''
        this.checkDataBack = ''
        this.$emit('checkval')
      } else {
        showAlert(errMsg)
      }
    },
    goCart () {
      // this.$emit('changeOrder')
      this.$router.push('/page_shopping_cart')
    }
  }
}
</script>

<style lang="less" scoped>
.sightseeing-card{
  ::v-deep .price-color{
    color: @second-color;
  }
  ::v-deep .blue-color{
    color: #1174b8;
  }
  .item-top-tag-box {
    padding: 20px 0 0;
    &.isTag {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
      & .item-top-tag-price {
        font-size: 24px;
        line-height: 1;
        color: #fbc300;
      }
      & .item-top-tag{
        margin: 0;
      }
      & .left{
        margin-left: 20px;
      }
    }
  }
  .item-top-tag{
    font-size: 26px;
    color: @main-gray3;
    padding: 5px 20px;
    width: 100px;
    text-align: center;
    background-color: #f0f0f0;
    //margin: 20px auto;
    // display: inline-block;
    margin: 0 auto;
    border-radius: 46px;
    padding-bottom: 0px;
  }
  .left{
    margin-left: 20px;
  }
  .card-bd{
    ::v-deep .van-cell{
      padding: 0.3rem 0.3rem 0;
    }
    .img-icon {
      height: 24px;
    }
    /deep/.van-radio__label{
      flex: 1;
    }
    /deep/.van-radio{
      align-items: flex-start;
      -webkit-align-items: flex-start;
      & .van-radio__icon {
        margin-top: -2px;
      }
    }
    // .item-top-tag{
    //   margin: 20px;
    // }
    .list-box{
      position: relative;
      border-bottom: 1px solid @main-gray5;
      //margin-bottom: 40px;
      padding: 30px 0 0;
      &:last-child{
        // display: none;
        //margin-bottom: 0;
      }
    }
    .list-del {
      margin-top: 20px;
      & .del-btn {
        width: 85px;
        height: 46px;
        line-height: 46px;
        color: #333333;
        text-align: center;
        border-radius: 6px;
        font-size: 18px;
        padding: 0;
        border:none;
      }
    }
    .list-hd{
      padding: 0 20px;
      ::v-deep .van-checkbox__label{
        width: 100%;
      }
      .item-hd{
        font-size: 20px;
        color: @main-gray4;
        .item-hd-left{
          font-size: 26px;
          padding-right: 105px;
          flex: 1;
          .price{
            font-size: 24px;
            .price-color{
              font-size: 30px;
            }
          }
        }
        .item-hd-right{
          text-align: right;
          .price-color{
            font-size: 30px;
          }
        }
      }
      .only-detail{
        align-items: flex-end;
        .price{
          font-size: 20px;
          .number{
            margin-left: 10px;
          }
        }
      }
    }
    ::v-deep .top-text-box{
      flex: 1;
      padding-left: 30px;
      font-size: 20px;
      line-height: 30px;
      margin-top: 5px;
      .title{
        font-size: 26px;
        color: @main-color;
      }
      .route{
        margin-top: 4px;
        color: @main-gray2;
      }
      .duration{
        color: @main-gray4;
        padding-top: 25px;
        line-height: 1;
      }
    }
    .top-text-tools {
      display: flex;
      justify-content: center;
      padding: 20px;
      & .tools-btn {
        width: 200px;
        height: 50px;
        line-height: 50px;
        color: #333333;
        text-align: center;
        border-radius: 6px;
        font-size: 24px;
        padding: 0;
        border:none;
      }
    }
    .routine-tour-box{
      background-color: #f5f7f8;
      .list-hd{
        margin-bottom: 20px;
        .item-hd{
          .item-hd-right{
            text-align: right;
            .price-color{
              font-size: 30px;
            }
          }
        }
      }
      .list-bd-top{
        padding: 0px 20px 20px;
      }
    }
  }
  .item-btn {
    width: 160px;
    height: 50px;
    border-radius: 6px;
    border: none;
    display: flex;
    align-items: center;
    text-align: center !important;
    ::v-deep .van-button__content{
      text-align: center !important;
    }
    .icon {
      margin-right: 5px;
      vertical-align: text-top;
    }
    &.btn-detail {
      color: #fff;
      background: #1174b8;
      .icon {
        width: 14px;
      }
    }
    &.btn-cart .icon {
      width: 21px;
    }
    &.del{
      width: 85px;
      ::v-deep .van-button__content{
        width: 100%;
      }
    }
  }
}
</style>
